export function NewsletterPost({
  post,
  isNew,
}: {
  post: string;
  isNew: boolean;
}) {
  return (
    <div
      // eslint-disable-next-line @eslint-react/dom/no-dangerously-set-innerhtml
      dangerouslySetInnerHTML={{ __html: post }}
      className={isNew ? "new" : ""}
    />
  );
}
